import React from 'react';
import styled from '@emotion/styled';
import { Color } from 'views/constants';
import { HeaderMenu } from 'views/components/atoms/HeaderMenu';
import { Typography } from 'views/components/atoms/Typography';
import { NotificationEmailForm } from 'views/components/organisms/NotificationEmailForm';

const HeaderContentWrapper = styled.div``;

const NotificationWrapper = styled.div`
  text-align: left;
`;

type NotificationSettingPageLayoutProps = {
  currentEmail?: string;
  notificationMessage?: string;
  onSave(email: string): void;
  onDelete(): void;
};

export const NotificationSettingPageLayout: React.FC<
  NotificationSettingPageLayoutProps
> = ({ currentEmail, notificationMessage, onSave, onDelete }) => {
  return (
    <>
      {notificationMessage !== undefined && notificationMessage !== '' ? (
        <HeaderMenu>
          <HeaderContentWrapper>
            <NotificationWrapper>
              <Typography bold color={Color.C3}>
                {notificationMessage}
              </Typography>
            </NotificationWrapper>
          </HeaderContentWrapper>
        </HeaderMenu>
      ) : null}

      <NotificationEmailForm
        currentEmail={currentEmail}
        onSave={onSave}
        onDelete={onDelete}
      />
    </>
  );
};
